<template>
  <div class="notification-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.notifications.title') }}</h1>
        <p>{{ $t('bo.notifications.subtitle') }}</p>
      </div>
    </div>

    <NotificationList
      ref="listRef"
      :deleting-id="deletingId"
      @delete="handleDelete"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import NotificationList from './NotificationList.vue'
import notificationAdminService from '@/services/notificationAdminService'

const { t } = useI18n()

const listRef = ref(null)
const deletingId = ref(null)

const handleDelete = async (id) => {
  if (!confirm(t('bo.notifications.confirmDelete'))) return
  deletingId.value = id
  try {
    await notificationAdminService.delete(id)
    listRef.value?.loadNotifications()
    listRef.value?.loadStats()
  } catch (e) {
    alert(e.response?.data?.message || t('bo.notifications.failedDelete'))
  } finally {
    deletingId.value = null
  }
}
</script>

<style scoped>
.notification-manager {
  padding: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}
</style>
